function createLanguageInterceptor({ language }) {
  return async (axiosRequestConfig) => {
    const { includeLanguage, ...requestConfig } = axiosRequestConfig;
    if (includeLanguage && language) {
      return {
        ...requestConfig,
        params: {
          ...requestConfig.params,
          language: typeof language === "function" ? await language() : language
        }
      };
    }
    return requestConfig;
  };
}

export { createLanguageInterceptor };
//# sourceMappingURL=language.js.map
